import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationMenuComponent } from './components/notification-menu/notification-menu.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NotificationRequestInterceptor } from './interceptors/notification-request.interceptor';
import { environment } from '@env';
import { SharedModule } from '@shared/shared.module';
import { InfiniteScrollComponent } from './components/infinite-scroll/infinite-scroll.component';
import { AccessModule } from '@access/access.module';



@NgModule({
  declarations: [
    NotificationMenuComponent,
    InfiniteScrollComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    AccessModule
  ],
  exports: [
    NotificationMenuComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NotificationRequestInterceptor,
      multi: true
    },
    {
      provide: 'NOTIFICATION_BASE_URL',
      deps: [],
      useFactory: () => { return environment.notificationService.baseUrl }
    }
  ]
})
export class NotificationsModule { }
